import React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function LayoutPanelRightOutline({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
            <rect
                x="2.25"
                y="2.25"
                width="13.5"
                height="13.5"
                rx="2"
                stroke={color}
                strokeWidth="1.2"
            />
            <line x1="11.46" y1="2.85" x2="11.46" y2="15.15" stroke={color} strokeWidth="1.2" />
        </svg>
    );
}

export default LayoutPanelRightOutline;
